<template>
  <div class="v-stack h-stretch gap-3">
    <div class="card light mn">
      <div class="content gap-3">
        <label class="text-right">Pay: </label>
        <div class="text-left">
          {{ currentPay }} Kč/hod ({{
            Math.round((currentPay * 8 * 252) / 12 / 1000) * 1000
          }}
          Kč/měsíc)
        </div>
      </div>
    </div>
    <a class="heading-title-2">Pay</a>
    <Table
      :items="pay"
      :defaultColumn="0"
      :columns="[
        {
          name: 'Date',
          sort: 'date',
          path: ['date'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Created By',
          sort: 'alphabet',
          path: ['createdBy', 'fullName'],
        },
        {
          name: 'Pay',
          sort: 'numeric',
          path: ['amount'],
          formatMap: (amount) =>
            `${Math.round(amount)} Kč/hod (${
              Math.round((amount * 8 * 252) / 12 / 1000) * 1000
            } Kč/měsíc)`,
        },
      ]"
    ></Table>
    <div class="h-stack h-end">
      <button
        v-if="$store.state.accessLevel > 9"
        class="add"
        @click="$router.push('/users/pay/new/' + (id || $store.state.id))"
      >
        Add
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
const moment = require("moment");
import Table from "@/components/Table.vue";

export default {
  props: ["id"],
  data() {
    return {
      pay: [],
    };
  },
  components: {
    Table,
  },
  computed: {
    currentPay() {
      let value = 0;

      const date = moment();
      let currentPay = null;
      for (const pay of this.pay) {
        const payDate = moment(pay.date);
        if (payDate.isSameOrBefore(date, "day")) {
          if (currentPay == null) {
            currentPay = pay;
          } else {
            const currentDate = moment(currentPay.date);
            if (currentDate.isBefore(payDate)) {
              currentPay = pay;
            }
          }
        }
      }

      if (currentPay) {
        value = Math.round(currentPay.amount);
      }

      return value;
    },
  },
  methods: {
    ...mapActions(["getUserPay"]),
    refresh() {
      this.getUserPay(this.id || this.$store.state.id)
        .then((pay) => {
          this.pay = pay;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatDate(dateString, format) {
      const date = moment(dateString);
      return date.format(format);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
label,
input {
  align-self: center;
}
</style>

<style lang="scss" scoped>
.pay-row {
  grid-auto-columns: 1fr 1fr !important;
  gap: 10px;
}
</style>
